import React, { createContext, useEffect, useMemo, useReducer } from 'react';
import managerConferenceActions from '@/actions/shared/managerConferenceActions';
import managerConferenceReducer from '@/reducers/shared/managerConferenceReducer';

export const ManagerConferenceContext = createContext();

const ManagerConferenceContextProvider = (props) => {
  const [conferenceData, dispatch] = useReducer(managerConferenceReducer, {
    updateProgress: false,
    updateError: false,
    conferenceProgress: false,
    conferenceLoaded: false,
    conferenceError: null,
    conference: null,
  });
  const actions = useMemo(() => managerConferenceActions(dispatch), [dispatch]);

  useEffect(() => {
    if (conferenceData.conferenceLoaded && conferenceData.conference) {
      document.title = conferenceData.conference.title + ' - Manager';
    }
  }, [conferenceData.conferenceLoaded, conferenceData.conference]);

  return (
    <ManagerConferenceContext.Provider
      value={{ conferenceData, dispatch, actions }}
    >
      {props.children}
    </ManagerConferenceContext.Provider>
  );
};

export default ManagerConferenceContextProvider;
